import { StoreAnimalWeights } from "./store-animal-weights";
import { Uuid } from "../../../domain/model/uuid/uuid.type";
import { StoreUpdateInfo } from "../../store-update-info";

export class StoreAnimalWeighingSaveInfo {

  constructor(
    readonly id: Uuid,
    readonly batchWeighingId: Uuid,
    readonly animalWeights: StoreAnimalWeights,
    readonly update: StoreUpdateInfo) { }
}
